<template>
  <div v-if="isMcom">
    <transition name="fade">
      <div v-if="showEngagement || !isPill" :class="engagementClasses">
        <div class="small c-legal c-capitalize" :class="{ 'best-seller': isBestSeller }" aria-live="polite" aria-relevant="text" aria-atomic="true">
          {{ productUnitSalesCountMessage }}
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { computed, onMounted, onUnmounted, ref, toValue } from 'vue';
import { useBrand } from '~/composables/useBrand';
import { useCommonProductGetters } from '~/composables/useCommonProductGetters';

let fadeTimeOut = 0;
const DISPLAY_DURATION = 5000;
const showEngagement = ref(false);
const props = defineProps({
  isBestSeller: {
    type: Boolean,
    default: false,
  },
  isPill: {
    type: Boolean,
    default: false,
  },
});

const { isMcom } = useBrand();
const { metric } = useCommonProductGetters();

const { productUnitSalesCountMessage } = toValue(metric) || {};
const engagementClasses = computed(() => [
  { 'engagement-mobile hide-for-medium': props.isPill },
  { 'margin-bottom-xs': props.isBestSeller },
  { 'margin-bottom-m margin-top-xs': !props.isPill && !props.isBestSeller },
  { 'prod-engage': !props.isBestSeller },
]);

onMounted(() => {
  showEngagement.value = true;

  fadeTimeOut = window.setTimeout(() => {
    showEngagement.value = false;
  }, DISPLAY_DURATION);
});
onUnmounted(() => window.clearTimeout(fadeTimeOut));
</script>

<style lang="scss" scoped>
.prod-engage {
  text-align: center;
}
.c-capitalize {
  text-transform: capitalize;
}
.best-seller {
  padding: 0.125rem 0.5rem;
  background-color: $background-color;
  width: max-content;
}
.engagement-mobile {
  width: max-content;
  position: absolute;
  bottom: rem-calc(65);
  left: 50%;
  transform: translateX(-50%);
  padding: rem-calc(12);
  background-color: rgba(0, 0, 0, 0.85);
  color: $white;
  border-radius: rem-calc(5);
  .small {
    color: $white;
  }
  &.fade-in {
    opacity: 1;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-in-out;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
